var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.439 14.8397C7.36952 17.3592 11.7807 17.0168 14.2913 14.0709C16.802 11.125 16.4583 6.69456 13.5278 4.17502C10.5973 1.65548 6.18612 1.99787 3.67548 4.94382C1.16485 7.88976 1.50849 12.3202 4.439 14.8397ZM3.14173 16.3619C6.80224 19.509 12.2565 19.1828 15.5232 15.6935L19.9015 19.4579C20.3203 19.8179 20.9502 19.769 21.3084 19.3487C21.6666 18.9284 21.6176 18.2957 21.1988 17.9357L16.7243 14.0887C18.9005 10.389 18.1876 5.5438 14.8251 2.65282C11.056 -0.587663 5.3852 -0.145711 2.15893 3.63995C-1.06734 7.4256 -0.627322 13.1214 3.14173 16.3619ZM6.5 9.08398C6.22386 9.08398 6 9.30784 6 9.58398C6 9.86013 6.22386 10.084 6.5 10.084H11.5C11.7761 10.084 12 9.86013 12 9.58398C12 9.30784 11.7761 9.08398 11.5 9.08398H6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion2);
export default __webpack_public_path__ + "static/media/Union2.c6893e556e000ad96de5007c387e25c1.svg";
export { ForwardRef as ReactComponent };